
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_1s97g_13",
  "drawer-closed": "awsui_drawer-closed_1r9lg_1s97g_50",
  "refresh": "awsui_refresh_1r9lg_1s97g_50",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_1s97g_54",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_1s97g_70",
  "position-bottom": "awsui_position-bottom_1r9lg_1s97g_77",
  "hidden": "awsui_hidden_1r9lg_1s97g_85",
  "drawer-clickable": "awsui_drawer-clickable_1r9lg_1s97g_96",
  "position-side": "awsui_position-side_1r9lg_1s97g_107",
  "with-toolbar": "awsui_with-toolbar_1r9lg_1s97g_112",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_1s97g_116",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_1s97g_127",
  "open-button-side": "awsui_open-button-side_1r9lg_1s97g_141",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_1s97g_150",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_1s97g_160",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_1s97g_164",
  "content-bottom": "awsui_content-bottom_1r9lg_1s97g_176",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_1s97g_195",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_1s97g_200",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_1s97g_204",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_1s97g_208",
  "content-side": "awsui_content-side_1r9lg_1s97g_213",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_1s97g_225",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_1s97g_234",
  "header": "awsui_header_1r9lg_1s97g_245",
  "header-main-row": "awsui_header-main-row_1r9lg_1s97g_253",
  "header-main-content": "awsui_header-main-content_1r9lg_1s97g_253",
  "header-tag-and-info": "awsui_header-tag-and-info_1r9lg_1s97g_267",
  "with-description": "awsui_with-description_1r9lg_1s97g_272",
  "header-tag": "awsui_header-tag_1r9lg_1s97g_267",
  "with-info": "awsui_with-info_1r9lg_1s97g_275",
  "header-text": "awsui_header-text_1r9lg_1s97g_275",
  "header-before-slot": "awsui_header-before-slot_1r9lg_1s97g_281",
  "with-header-text": "awsui_with-header-text_1r9lg_1s97g_292",
  "header-actions-slot": "awsui_header-actions-slot_1r9lg_1s97g_298",
  "header-description": "awsui_header-description_1r9lg_1s97g_304",
  "header-buttons": "awsui_header-buttons_1r9lg_1s97g_311",
  "divider": "awsui_divider_1r9lg_1s97g_319"
};
  